<template>
  <section class="-mx-3">
    <div class="text-center mx-auto">
      <square-option
        v-for="(option, index) in $store.state.data.Steps[$store.state.activeStep]
          .Options"
        :key="option.Id"
        :isActive="isActiveStep(index)"
        @click.native="
          setSelectedTile(index);
          setUserInput({
            [$store.state.data.Steps[$store.state.activeStep]
              .SalesforcePropertyKey]: option.SalesforcePropertyValue
          });
          setNextStep();
        "
      >
        <div class="p-3 text-left">
          <div class="aspect-w-1 aspect-h-1">
            <img
              class="w-full h-full object-cover"
              :src="option.ImageUrl"
              alt="image"
            />
          </div>
          <p
            v-if="option.Description != '' && option.Title"
            class="text-lg mb-2 md:text-xl mt-3"
          >
            {{ option.Title }}
          </p>
          <p v-if="option.Description" class="text-xs md:text-base mt-0">
            {{ option.Description }}
          </p>
        </div>
        <template
          v-if="option.Description == '' && option.Title"
          v-slot:text-below
          >{{ option.Title }}</template
        >
      </square-option>
    </div>
  </section>
</template>

<script>
import SquareOption from "../shared/SquareOption";
import { mapGetters } from "vuex";

export default {
  components: {
    SquareOption
  },
  computed: {
    ...mapGetters([
      "getActiveStepId"
    ]),
  },
  methods: {
    setNextStep() {
      this.$store.commit("nextStep");
    },
    setUserInput(data) {
      this.$store.commit("updateUserInput", data);
    },
    setSelectedTile(index) {
      this.$store.commit("setSelectedTileIndex", index);
      this.$store.commit("setActiveSelection");
    },
    isActiveStep(index) {
      const selectedKey = this.$store.state.activeSelection[this.getActiveStepId];
      return (selectedKey == index) ? true : false;
    }
  }
};
</script>
